export const employeeValidationRules = (values) => {
  const errors = {};
  const phoneRegex = /^\+[1-9]\d{0,3}\d{6,11}$/;

  if (!values.name) errors.name = "Name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (values.primaryPhone && !phoneRegex.test(values.primaryPhone))
    errors.primaryPhone = "Enter valid number (with country code)";

  return errors;
};
